import {FormCommentsField, FormDatePicker, FormRadioGroup} from "base/form/components";
import Grid from "@mui/material/Grid";
import DateUtil from "base/format/utilities/DateUtil";

const PermitExtensionInitialFormFields = ({minDate}) => {
    const decisionOptions = [
        {value: true, label: "Total"},
        {value: false, label: "Parcial"},
    ];

    return (
        <Grid container columnSpacing={4}>
            <Grid item xs={6}>
                <FormDatePicker
                    name="application_date"
                    label="Data de solicitação"
                    rules={{required: "Este campo é obrigatório."}}
                    disableFuture={true}
                    minDate={DateUtil.parseDateFromApi(minDate)}
                />
            </Grid>
            <Grid item xs={6}>
                <FormRadioGroup
                    name="is_total"
                    label="Prorrogação"
                    options={decisionOptions}
                    row
                    rules={{required: "Este campo é obrigatório."}}
                />
            </Grid>
            <Grid item xs={12}>
                <FormCommentsField />
            </Grid>
        </Grid>
    );
};

export default PermitExtensionInitialFormFields;
